import * as React from 'react';
import { useEffect } from 'react';
import { AppRoutes } from "./utils/ProtectedRoute";
import Layout from './components/Layout';
import userManager, { loadUserFromStorage } from 'shared/services/userService';
import { loadDocumentTypes } from 'shared/services/documentTypeService';
import appSettings from 'shared/settings/appSettings';
import { initRelatedDocs } from 'components/ui/DocumentRules';
import AuthProvider from 'authProvider';
import './assets/css/formatting.css'
import './assets/css/typography.css'
import './assets/css/colors.css';
import './assets/css/custom.css';
import { configure } from 'shared/helpers/colorManager';
import useSelector from 'hooks/useSelector';
import { RulebookEnumToString, RulebookModeEnum, RulebookNameToEnum } from './shared/enums/rulebook-mode-enum';
import { loadFeatureToggles } from './shared/services/featureToggleService';

configure();

export default () => {
    var initialised: boolean = false;
    const profile = useSelector(state => state.profile);

    const initiailiseState = async () => {
        if (!initialised && profile?.id) {
            await loadDocumentTypes();
            await loadFeatureToggles();
            await initRelatedDocs(RulebookEnumToString(RulebookModeEnum.Traditional));
            if (profile.cbtcTrained) {
                await initRelatedDocs(RulebookEnumToString(RulebookModeEnum.CBTC));
            }            
            initialised = true;
        }

    };

    useEffect(() => {
        // fetch current user from cookies
        loadUserFromStorage();
        const mount = async () => {
            const user = await userManager.getUser();
            if (user)
                initiailiseState();
        }
        mount();

    }, [profile]);

    useEffect(() => {
        document.title = `BHP Rail Portal${appSettings.environmentIndicator}`;
    }, []);

    return (
        <AuthProvider userManager={userManager.getProxiedObject()} onUserLoaded={initiailiseState}>
        <Layout>
            <AppRoutes />
        </Layout>
        </AuthProvider>
    );
};
